import QuestionnairesDataTable from "../../../components/dataTable/tables/questionnaire/QuestionnairesDataTable";

function QuestionnairesPageView() {
  return <QuestionnairesDataTable />;
}

export default QuestionnairesPageView;
